const ScreenData = {
  Project_Team: 1,
  Project_Vehicle: 2,
  Vehicle_Reading: 3,
  Vehicle_Insurance: 4,
  Stock_In: 5,
  Stock_Out: 6,
  Stock_Transfer: 7,
  Stock_Return: 8,
  Stock_Indent: 9,
  Stock_Info: 10,
  Project: 11,
  Project_Stores: 12,
  Project_Locations: 13,
  Project_Items: 14,
  Daily_Report: 15,
  Petty_Cash: 16,
  Vehicle_Registration: 17,
  Vehicle_Hire: 18,
  Vehicle_Service: 19,
  Vehicle_Tax: 20,
  Daily_Fuel_Entry: 21,
  Employee: 22,
  Vehicle_Transfer_Request: 23,
  Pay_Petty_Cash: 24,
  Project_Estimates: 25,
  Stock_Receive: 26,
  Stock_Sales: 27,
  Fuel_Purchase: 28
};

export default ScreenData;